<template>
  <div
    v-if="typeof localValue === 'boolean'"
    :class="$style.base"
  >
    <BaseHeading
      size="l"
      :mb="2"
    >
      {{ $t('admin.assistant.waiting_list.heading') }}
    </BaseHeading>
    <div :class="$style.form">
      <RadioCards
        v-model="localValue"
        :options="[
          {
            label: $t('admin.assistant.waiting_list.option_1.heading'),
            image: `/img/salonized-assistant/${getImageLanguage}/waitinglist-no.png`,
            value: false
          },
          {
            label: $t('admin.assistant.waiting_list.option_2.heading'),
            image: `/img/salonized-assistant/${getImageLanguage}/waitinglist-yes.png`,
            value: true
          }
        ]"
      />
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import getImageLanguage from '../imageLanguage';
import RadioCards from './_shared/RadioCards.vue';

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue?: boolean | null;
}>();

const localValue = ref(props.modelValue);

watch(
  localValue,
  () => {
    emit('update:modelValue', localValue.value);
  },
  {
    deep: true,
  },
);
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.form {
  flex-grow: 1;
}
</style>
